var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState } from "react";
import { Button, Tooltip } from "tombac";
import { LimitsIcon } from "tombac-icons";
import { LimitUsage } from "../../components/Limits/LimitUsage";
import { StyledLimits } from "../../components/Limits/StyledLimits";
import { TrialLimitsSummary } from "../../components/Trial";
import useOutsideClick from "../../useOutsideClick";
import { useLegoland } from "../LegolandContext";
import { AccessType, useLimitSchemasQuery, useMeProductAccessQuery, useUserProduct, } from "../legolandApi";
import { Dot, IconButton } from "./IconButton";
function createLimitsWithUsage(limits, schema, usage, limitsSharedWith) {
    var limitsWithUsage = Object.entries(limits)
        .filter(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], limit = _b[1];
        return limit !== null;
    })
        .map(function (_a) {
        var _b;
        var _c = __read(_a, 2), limitName = _c[0], limit = _c[1];
        var limitSchema = schema.find(function (s) { return s.name === limitName; });
        var limitUsage = usage[limitName];
        var sharedWith = (_b = limitsSharedWith === null || limitsSharedWith === void 0 ? void 0 : limitsSharedWith.find(function (_a) {
            var names = _a.names;
            return names.includes(limitName);
        })) === null || _b === void 0 ? void 0 : _b.productId;
        return { limit: limit, schema: limitSchema, sharedWith: sharedWith, usage: limitUsage };
    })
        .filter(function (l) { var _a, _b; return ((_a = l.schema) === null || _a === void 0 ? void 0 : _a.customizable) === true && ((_b = l.schema) === null || _b === void 0 ? void 0 : _b.visible) === true; });
    return limitsWithUsage.length > 0 ? limitsWithUsage : undefined;
}
export var LegolandNavbarLimits = function (_a) {
    var _b, _c;
    var track = _a.track;
    var _d = useLegoland(), legolandUiUrl = _d.legolandUiUrl, productId = _d.productId;
    var product = useUserProduct({ productId: productId });
    var schemaQuery = useLimitSchemasQuery({ productId: productId }, { enabled: Boolean(productId) });
    var accessQuery = useMeProductAccessQuery();
    var productAccess = (_b = accessQuery.data) === null || _b === void 0 ? void 0 : _b.access;
    var _e = productAccess !== null && productAccess !== void 0 ? productAccess : {}, limits = _e.limits, limitsSharedWith = _e.limitsSharedWith, usage = _e.usage;
    var schemas = (_c = schemaQuery.data) === null || _c === void 0 ? void 0 : _c.schemas;
    var _f = __read(useState(), 2), limitsWithUsage = _f[0], setLimitsWithUsage = _f[1];
    useEffect(function () {
        if (!limits || !schemas || !usage)
            return;
        setLimitsWithUsage(createLimitsWithUsage(limits, schemas, usage, limitsSharedWith));
    }, [limits, limitsSharedWith, schemas, usage]);
    var _g = __read(useState(false), 2), showLimits = _g[0], setShowLimits = _g[1];
    var _h = __read(useState(null), 2), limitsRef = _h[0], setLimitsRef = _h[1];
    var closeLimits = useCallback(function () { return setShowLimits(false); }, [setShowLimits]);
    useOutsideClick(limitsRef, closeLimits);
    return productAccess && limitsWithUsage && product ? (React.createElement(StyledLimits.Container, { ref: setLimitsRef, onClick: function () {
            track("page_click", {
                specificProps: {
                    component_name: "header",
                    component_sub_name: "limits-button",
                },
            });
            setShowLimits(function (x) { return !x; });
        } },
        React.createElement(Tooltip, { content: "Usage\u00A0limits", placement: "bottom", size: "s", variant: "inverted" }, function (_a) {
            var close = _a.close, open = _a.open, ref = _a.ref;
            return (React.createElement(IconButton, { onMouseEnter: function () { return !showLimits && open(); }, onMouseLeave: close, ref: ref, shape: "circle", variant: "flat" },
                React.createElement(LimitsIcon, null),
                productAccess.type === AccessType.Evaluation && (React.createElement(Dot, { breakpoint: 0, variant: "alert" }))));
        }),
        showLimits && (React.createElement(StyledLimits.Popup.Container, null,
            React.createElement(StyledLimits.Popup.Header, null,
                React.createElement(StyledLimits.Popup.Title, null, "Usage limits"),
                React.createElement(StyledLimits.Popup.Subtitle, null, product === null || product === void 0 ? void 0 : product.displayName)),
            (productAccess === null || productAccess === void 0 ? void 0 : productAccess.type) === AccessType.Evaluation && (React.createElement(StyledLimits.Popup.Item, null,
                React.createElement(TrialLimitsSummary, { productAccess: productAccess, activeProduct: productId }))),
            limitsWithUsage.map(function (l) {
                return l.schema && React.createElement(LimitUsage, { key: l.schema.name, limitWithUsage: l });
            }),
            (productAccess === null || productAccess === void 0 ? void 0 : productAccess.type) === AccessType.Evaluation ? (React.createElement(StyledLimits.Popup.Footer, { isTrial: true },
                React.createElement("div", null,
                    React.createElement(StyledLimits.Popup.FooterTitle, null, "Do you want to upgrade and gain access to more features?"),
                    React.createElement(StyledLimits.Popup.FooterDescription, null, "Contact us")),
                React.createElement(Button, { "$flex": "none", "$marginLeft": "2sp", as: "a", href: "".concat(legolandUiUrl, "/dashboard/contact"), size: "s", target: "_blank", variant: "alert" }, "Contact us"))) : (React.createElement(StyledLimits.Popup.Footer, null,
                React.createElement(StyledLimits.Popup.FooterTitle, null, "Do you need more?"),
                React.createElement(StyledLimits.Popup.FooterDescription, null, "Contact your distributor to change your limits"))))))) : null;
};
//# sourceMappingURL=LegolandNavbarLimits.js.map